
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Card from "./Card";
import { FaViber } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa6";
import { AiFillInstagram } from "react-icons/ai";

function SearchCars({ category, allFilters }) {
  const [carManufacturers, setCarManufacturers] = useState([])
  const [carModels, setCarModels] = useState([])
  const [carEngines, setCarEngines] = useState([])
  const [selectedCarManufacuturer, setSelectedCarManufacuturer] = useState('')
  const [selectedCarModel, setSelectedCarModel] = useState('')
  const [selectedEngineId, setSelectedEngineId] = useState('')
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const API_URL = process.env.REACT_APP_API_URL;
  const viberNumber = "+38974229595"; // Твојот број
  const viberLink = `viber://chat?number=${encodeURIComponent(viberNumber)}`;
  const viberWebLink = `https://invite.viber.com/?g2=demo&lang=en&number=${encodeURIComponent(viberNumber)}`;


  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    fetchCarManufacturers()
  }, [])

  useEffect(() => {
    if (carManufacturers.length > 0) {
      const queryParams = new URLSearchParams(location.search);
      setSelectedCarManufacuturer(queryParams.get('cmfr') || '');
      setSelectedCarModel(queryParams.get('cmd') || '');
      setSelectedEngineId(queryParams.get('ceng') || '');
    }
  }, [carManufacturers])

  const fetchCarManufacturers = async () => {
    try {
      const response = await fetch(`${API_URL}/car/cars`)

      const result = await response.json()
      setCarManufacturers(result.data)
      setLoading(false)
    }
    catch (error) {
    }
  }

  useEffect(() => {
    if (selectedCarManufacuturer) {
      fetchModels()
    }
  }, [selectedCarManufacuturer])

  const fetchModels = async () => {
    try {
      setLoading(true)
      const response = await fetch(`${API_URL}/car/carModels?carManufacturerId=${selectedCarManufacuturer}`)

      const result = await response.json()

      setCarModels(result.data)
      setLoading(false)
    }
    catch (Error) {
    }
  }

  useEffect(() => {
    if (selectedCarModel) {
      fetchEngines()
    }
  }, [selectedCarModel])

  useEffect(() => {
    if (selectedEngineId) {
      fetchItems()
    }
  }, [selectedEngineId])

  const fetchEngines = async () => {
    try {
      setLoading(true)
      const response = await fetch(`${API_URL}/car/modelEngines?carModelId=${selectedCarModel}`)

      const result = await response.json()
      setCarEngines(result.data)
      setLoading(false)
    }
    catch (error) {
    }
  }

  const handleManufacturerChange = (e) => {
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.delete('cmd');
    newQueryParams.delete('ceng');
    const { name, value } = e.target;

    if (value) {
      const parsedValue = tryParseJSON(value)
      newQueryParams.set(name, parsedValue);
    } else {
      newQueryParams.delete(name); // Избриши ако нема вредност
    }

    const selectedMake = tryParseJSON(e.target.value)
    setSelectedCarManufacuturer(selectedMake)
    setCarModels([])
    setCarEngines([])
    setSelectedCarModel('')
    setSelectedEngineId('')
    setItems([])
    navigate({ search: newQueryParams.toString() });
  };

  const handleCarModelChange = (e) => {
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.delete('ceng');
    const { name, value } = e.target;

    if (value) {
      const parsedValue = JSON.parse(value)
      newQueryParams.set(name, parsedValue);
    } else {
      newQueryParams.delete(name); // Избриши ако нема вредност
    }

    setSelectedEngineId('')
    setItems([])
    setSelectedCarModel(e.target.value)

    navigate({ search: newQueryParams.toString() });
  }

  const handleEngine = (e) => {
  
    const newQueryParams = new URLSearchParams(location.search);
    const { name, value } = e.target;

    if (value) {
      const parsedValue = JSON.parse(value)
      newQueryParams.set(name, parsedValue);
    } else {
      newQueryParams.delete(name); // Избриши ако нема вредност
    }

    setSelectedEngineId(e.target.value)
    navigate({ search: newQueryParams.toString() });
  }

  const fetchItems = async () => {

    try {
      setLoading(true)
      const response = await fetch(`${API_URL}/Car/engineFilters?carEngineId=${selectedEngineId}&category=${category}`)

      const result = await response.json()
  
      if (result.data == null) {
        setItems([])
      } else {
        setItems(result.data)
      }
      setLoading(false)
    }
    catch (error) {
    }
  }

  const tryParseJSON = (value) => {
    try {
      return JSON.parse(value);
    } catch (e) {
      return null; // Return null or handle the error as needed
    }
  }

  useEffect(() => {
    if (items.length != 0) {
      const savedScrollPos = sessionStorage.getItem(location.pathname);
      if (savedScrollPos) {
        window.scrollTo(0, parseInt(savedScrollPos, 10));
      }
    }


  }, [items]); // Re-run after loading and location change

  useEffect(() => {
    return () => {
      if (!items.length != 0) {
        sessionStorage.setItem(location.pathname, window.scrollY);
      }
    };
  }, [location]);

  const handleViberClick = (event) => {
    if (navigator.userAgent.match(/iPhone|iPad|Android/i)) {
      window.location.href = viberLink;
    } else {
      window.open(viberWebLink, "_blank");
    }
  };

  if (loading) {
    return <div className='text-xl'>Loading...</div>; // Or any loading indicator you prefer
  }

  return (
    <>
      <div className='flex flex-wrap justify-center items-center mb-5'>
        <div className='mr-4 width-max' >
          <select name='cmfr' value={selectedCarManufacuturer} onChange={handleManufacturerChange} className="select select-bordered w-[300px] max-w-xs mb-5" disabled={loading ? 'disabled' : ''}>
            <option value='' defaultValue>Одберете марка</option>
            {carManufacturers.map((car) => (
              <option key={car.id} value={JSON.stringify(car.id)}>{car.manufacturer}</option>
            ))}
          </select>
        </div>
        <div className='mr-4 width-max'>
          <select name='cmd' value={selectedCarModel} onChange={handleCarModelChange} className="select select-bordered w-[300px] max-w-xs mb-5" disabled={loading ? 'disabled' : ''}>
            <option value='' defaultValue>Одберете модел</option>
            {carModels.map((car) => (
              <option key={car.id} value={car.id}>{car.modelType} ({car.code}) ({car.yearRangeProduction})</option>
            ))}
          </select>
        </div>
        <div className='mr-4 width-max'>
          <select name='ceng' value={selectedEngineId} onChange={handleEngine} className="select select-bordered w-[300px] max-w-xs mb-5" disabled={loading ? 'disabled' : ''}>
            <option value='' defaultValue >Одберете мотор</option>
            {carEngines.map((engine) => (
              <option key={engine.id} value={engine.id} >{`${engine.model} ${engine.description} - ${engine.kw} / ${engine.hp} (${engine.modelYear}`})</option>
            ))}
          </select>
        </div>
      </div>
      <div className='flex flex-wrap justify-center items-center'>
        {selectedEngineId && items.length === 0 ? (
          <>
            <span className="flex flex-wrap items-center gap-2">
              Контактирајте не со клик на: <a className="inline-flex items-center gap-1" href={viberLink} onClick={handleViberClick} target="_blank" rel="noopener noreferrer">
                <FaViber className="text-2xl" />
                {viberNumber}
              </a>
              <span>|</span>
              <a href="https://www.facebook.com/profile.php?id=61575622274790" target="_blank" rel="noopener noreferrer">
                <FaFacebookF className="text-2xl" />
              </a>
              <span>|</span>
              <a href="https://www.instagram.com/malservis.mk/" target="_blank" rel="noopener noreferrer">
                <AiFillInstagram className="text-2xl" />
              </a>
              <span>и во најкраток можен рок ќе Ви пратиме понуда за Вашиот автомобил.</span>
            </span>
          </>
        ) : (
          <>
            {items.length >= 1 && items.some(item => item.additionalDescription) && (
              <div className='mb-4'>
                <p className='text-xs'>*<span className='font-bold text-l'>Број на шасија (VIN)</span> можете да го најдете во сообраќајната дозвола од Вашиот автомобил под ознака <span className='font-bold text-l'>E</span></p>
                <p className='text-xs'>*<span className='font-bold text-l'>Број на мотор</span> можете да го најдете во сообраќајната дозвола од Вашиот автомобил под ознака <span className='font-bold text-l'>P.5</span></p>
                <p className='text-xs'>*<span className='font-bold text-l'>Код на мотор</span> можете да го најдете во сообраќајната дозвола од Вашиот автомобил под ознака <span className='font-bold text-l'>21</span></p>
                <p className='text-xs'>*<span className='font-bold text-l'>Година на производство</span> можете да најдете во сообраќајната дозвола од Вашиот автомобил под ознака <span className='font-bold text-l'>5А</span></p>
              </div>
            )}
            {items.some(item => item.category === 2) && (
              <div className={`w-full ${allFilters ? 'shadow-lg p-4' : ''}`}>
                {allFilters && <h3 className='text-4xl text-myOrange text-center mb-4'>Филтри за Масло</h3>}
                <div className='flex flex-wrap justify-center'>
                  {items
                    .filter(item => item.category === 2)
                    .map((item) => (
                      <Card key={item.id} item={item} type={'Филтер за Масло'} allFilters={allFilters} selectedCarEngineId={selectedEngineId} className='mr-4 mb-4' />
                    ))}
                </div>
              </div>
            )}

            {items.some(item => item.category === 3) && (
              <div className={`w-full ${allFilters ? 'shadow-lg p-4' : ''}`}>
                {allFilters && <h3 className='text-4xl text-myOrange text-center mb-4 mt-4'>Филтри за Воздух</h3>}
                <div className='flex flex-wrap justify-center'>
                  {items
                    .filter(item => item.category === 3)
                    .map((item) => (
                      <Card key={item.id} item={item} type={'Филтер за Воздух'} allFilters={allFilters} selectedCarEngineId={selectedEngineId} className='mr-4 mb-4' />
                    ))}
                </div>
              </div>
            )}

            {items.some(item => item.category === 4) && (
              <div className={`w-full ${allFilters ? 'shadow-lg p-4' : ''}`}>
                {allFilters && <h3 className='text-4xl text-myOrange text-center mb-4 mt-4'>Филтри за Гориво</h3>}
                <div className='flex flex-wrap justify-center'>
                  {items
                    .filter(item => item.category === 4)
                    .map((item) => (
                      <Card key={item.id} item={item} type={'Филтер за Гориво'} allFilters={allFilters} selectedCarEngineId={selectedEngineId} className='mr-4 mb-4' />
                    ))}
                </div>
              </div>
            )}
            {items.some(item => item.category === 5) && (
              <div className={`w-full ${allFilters ? 'shadow-lg p-4' : ''}`}>
                {allFilters && <h3 className='text-4xl text-myOrange text-center mb-4 mt-4'>Филтри за Кабина</h3>}
                <div className='flex flex-wrap justify-center'>
                  {items
                    .filter(item => item.category === 5)
                    .map((item) => (
                      <Card key={item.id} item={item} type={'Филтер за Кабина'} allFilters={allFilters} selectedCarEngineId={selectedEngineId} className='mr-4 mb-4' />
                    ))}
                </div>
              </div>
            )}
          </>
        )}
        {!selectedEngineId && (
          <p>Одберете го вашето возило за да ви се прикажат соодветните филтри.</p>
        )}
      </div>
    </>
  )
}

export default SearchCars
